// extracted by mini-css-extract-plugin
export default {"root":"Qgg1y","link":"FLwPy","myMessage":"MNp8R"};